import * as pica from 'pica/dist/pica.min'; // import minified version directly because react-scripts minifier can not minify this lib

interface ImageSize {
    width: number;
    height: number;
}

export const BaseColor: string = '#95c11f';

export const Pica: any = new pica();

export const LoupeSize: number = 32;
export const LoupeInViewSize: number = 80;

export const HoverTimeout: number = 200;

export const InitScrollWithInput: number = 50;

export const ProjectPreviewImage: ImageSize  = {
    width: 260,
    height: 212
};

export const ProjectPreviewImageOnPhone: ImageSize  = {
    width: 83,
    height: 83
};

export const ShareImageSize: ImageSize = {
    width: 1920,
    height: 1080
};

export const DownloadImageSize: ImageSize = {
    width: 1920,
    height: 1080
};

export const WATERMARK_RIGHT_URL: string = './images/powered_by_pCon.png';
export const WATERMARK_LEFT_URL: string | null = null;
export const WATERMARK_MARGIN_LEFT: number = 10;
export const WATERMARK_MARGIN_RIGHT: number = 10;
export const WATERMARK_MARGIN_BOTTOM: number = 10;
export enum LayoutType {
    SMALL = 1, /* height and width < 921px */
    TABLET = 2, /* (height or width > 920px) and width < 1025 px */
    DESKTOP = 3 /* width > 1024px */
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/LayoutConstants.ts